module.exports = __webpack_public_path__ + "img/2021_PhotoGrid_1613129429415.ce00343b.jpg";